<template>
  <div class="content" v-loading.fullscreen.lock="loading">
    <base-header class="pb-6">
      <div class="row align-items-center py-2">
        <div class="col-lg-6 col-7">
          <!-- Could place a headline or breadcrumb here -->
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--6">
      <div>
        <!-- <div class="dash-header mb-4">
          <h2 class="text-default m-0 d-flex">
            User Activity History
            <img src="/signup-img/fire.svg" alt="" />
          </h2>
        </div> -->
        <card class="no-border-card" footer-classes="pt-1">
          <template slot="header">
            <div class="row align-items-center">
              <div class="col-md-6 col-lg-6">
                <!-- Headline or breadcrumb can go here -->
                <h2 class="mb-0">User Activity Report</h2>
              </div>
              <div class="col-lg-6 col-md-6 col-12 text-right">
                <base-button
                  name="Clear Filters"
                  class="custom-btn"
                  @click="resetFilters"
                >
                  <i class="fa fa-refresh" aria-hidden="true"></i>
                  Clear Filters
                </base-button>
                <base-button
                  type="primary"
                  class="custom-btn"
                  name="Export Excel"
                  @click="exportExcel"
                >
                  Excel Download
                </base-button>
              </div>
            </div>
          </template>

          <div>
            <!-- FILTERS (Row 1) -->
            <div class="row d-flex justify-content-center justify-content-sm-between flex-wrap">
              <div class="col-md-3">
                <base-input
                  label="Search:"
                  name="Search"
                  class="search-style"
                  v-model="searchQuery"
                  prepend-icon="fas fa-search"
                  placeholder="Search Keyword"
                />
              </div>
              <div class="col-md-3">
                <base-input label="Date Range:">
                  <el-date-picker
                    v-model="filters.report_date"
                    @change="fetchData"
                    type="daterange"
                    unlink-panels
                    value-format="MM/dd/yyyy"
                    range-separator="-"
                    start-placeholder="Start date"
                    end-placeholder="End date"
                    style="width: 100%"
                  />
                </base-input>
              </div>
              <div class="col-md-3">
                <base-input label="Activity Type:">
                  <el-select
                    class="select-primary select-style w-100"
                    filterable
                    v-model="filters.activity_type"
                    @change="fetchData"
                    placeholder="Filter by Activity"
                  >
                    <el-option-group
                      v-for="group in activityTypeOptions"
                      :key="group.label"
                      :label="group.label"
                    >
                      <el-option
                        v-for="item in group.options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-option-group>
                  </el-select>
                </base-input>
              </div>
              <div class="col-md-3">
                <base-input label="User Status:">
                  <el-select
                    class="select-primary select-style w-100"
                    v-model="filters.employeStatus"
                    @change="changePage(1)"
                    placeholder="Filter by status"
                  >
                    <el-option
                      v-for="item in status"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </base-input>
              </div>
              <div class="col-md-3" v-if="showUserTypeFilter">
                <base-input label="User Type:">
                  <el-select
                    class="select-primary select-style w-100"
                    v-model="filters.user_type"
                    @change="changePage(1)"
                    placeholder="Filter by user type"
                  >
                    <el-option
                      v-for="item in userTypeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </base-input>
              </div>
            </div>

            <!-- MAIN TABLE -->
            <div class="user-eltable table-style-fancy border overflow-hidden">
              <el-table
                :data="tableData"
                stripe
                highlight-current-row
                lazy
                row-key="id"
                id="tableOne"
                header-row-class-name="thead-light"
                class="loginReportGrid table-striped"
              >

                <!-- Performed By Column -->
                <el-table-column min-width="140px" prop="performed_by_name">
                  <template slot="header">
                    <span @click="sortByColumn(0)">
                      Performed By
                      <i
                        v-if="sortedColumn === 0 && order === 'asc'"
                        class="fas fa-arrow-up text-blue linkColor"
                      />
                      <i
                        v-else
                        class="fas fa-arrow-down text-blue linkColor"
                      />
                    </span>
                  </template>
                  <template slot-scope="props">
                    {{ props.row.performed_by_name }}
                  </template>
                </el-table-column>

                <!-- Activity Type Column -->
                <el-table-column min-width="120px" prop="activity_type_label">
                  <template slot="header">
                    <span @click="sortByColumn(1)">
                      Activity
                      <i
                        v-if="sortedColumn === 1 && order === 'asc'"
                        class="fas fa-arrow-up text-blue linkColor"
                      />
                      <i
                        v-else
                        class="fas fa-arrow-down text-blue linkColor"
                      />
                    </span>
                  </template>
                  <template slot-scope="props">
                    {{ props.row.activity_type_label }}
                  </template>
                </el-table-column>

                <!-- Performed On Column -->
                <el-table-column min-width="140px" prop="performed_on_name">
                  <template slot="header">
                    <span @click="sortByColumn(2)">
                      Performed On
                      <i
                        v-if="sortedColumn === 2 && order === 'asc'"
                        class="fas fa-arrow-up text-blue linkColor"
                      />
                      <i
                        v-else
                        class="fas fa-arrow-down text-blue linkColor"
                      />
                    </span>
                  </template>
                  <template slot-scope="props">
                    <span v-if="props.row.performed_on_name">
                      {{ props.row.performed_on_name }}
                    </span>
                    <span v-else>--</span>
                  </template>
                </el-table-column>

                <!-- Description Column -->
                <el-table-column min-width="180px" prop="description_text">
                  <template slot="header">
                    <span @click="sortByColumn(3)">
                      Description
                      <i
                        v-if="sortedColumn === 3 && order === 'asc'"
                        class="fas fa-arrow-up text-blue linkColor"
                      />
                      <i
                        v-else
                        class="fas fa-arrow-down text-blue linkColor"
                      />
                    </span>
                  </template>
                  <template slot-scope="props">
                    <!-- {{ props.row.description_text }}  -->
                    <!-- <span v-html="props.row.description_text"></span> -->
                    <span>
                      <template v-for="(part, index) in formatDescription(props.row.description_text)">
                        <span v-if="part.type">
                          <el-tooltip
                            :content="detailsTooltip"
                            placement="top"
                            effect="dark"
                            :visible.sync="lastHoveredId === part.number"
                          >
                            <a
                              href="javascript:void(0)"
                              @click="handleNumberClick(part.number, part.type)"
                              @mouseover="handleNumberHover(part.number, part.type)"
                            >
                              {{ part.text }}
                            </a>
                          </el-tooltip>
                        </span>
                        <span v-else>{{ part.text }}</span>
                      </template>
                    </span>
                  </template>
                </el-table-column>

                <!-- Date/Time Column -->
                <el-table-column min-width="130px" prop="created_at">
                  <template slot="header">
                    <span @click="sortByColumn(4)">
                      Activity Date
                      <i
                        v-if="sortedColumn === 4 && order === 'asc'"
                        class="fas fa-arrow-up text-blue linkColor"
                      />
                      <i
                        v-else
                        class="fas fa-arrow-down text-blue linkColor"
                      />
                    </span>
                  </template>
                  <template slot-scope="props">
                    {{ props.row.created_at }}
                  </template>
                </el-table-column>

                <!-- Action Column (View Details) -->
                <el-table-column min-width="100px">
                  <template slot="header">
                    Action
                  </template>
                  <template slot-scope="props">


                    <el-tooltip content="Download User Report" placement="top">
                      <base-button
                        @click.prevent="downloadUserReport(props.row.user_id)"
                        class="like btn-link"
                        type=""
                        size="lg"
                        icon
                        style="color:white;">
                        <i class="text-primary fas fa-download"></i>
                      </base-button>
                    </el-tooltip>
                </template>
                </el-table-column>
              </el-table>
            </div>
          </div>

          <!-- PAGINATION FOOTER -->
          <div slot="footer" class="d-flex justify-content-between align-items-center">
            <!-- Switch for Super Admin entries -->
            <div class="d-flex align-items-center">
              <label class="mb-0 mr-2">Super Admin entries:</label>
              <base-switch
                v-model="showSuperAdmin"
                @input="onSuperAdminToggle"
                type="success"
              ></base-switch>
            </div>

            <nav v-if="pagination && tableData.length > 0">
              <div class="row">
                <div class="col-md-12">
                  <ul class="pagination custompagination justify-content-end align-items-center">
                    <p class="p-0 m-0 mr-2 d-flex align-items-center">
                      <span class="mr-1">Showing</span>
                      <el-select
                        class="select-primary pagination-select mx-1"
                        v-model="perPage"
                        @change="changePage(1)"
                        placeholder="Per page"
                        size="mini"
                        style="width: auto; display: inline-block;"
                      >
                        <el-option
                          class="select-primary"
                          v-for="item in perPageOptions"
                          :key="item"
                          :label="item"
                          :value="item"
                        ></el-option>
                      </el-select>
                      <span class="ml-1">of {{ totalData }} entries</span>
                    </p>
                    <li class="page-item" :class="{ disabled: currentPage === 1 }">
                      <a class="page-link" href="#" @click.prevent="changePage(currentPage - 1)">
                        <i class="fa fa-caret-left"></i>
                      </a>
                    </li>
                    <li
                      v-for="(page, index) in pagesNumber"
                      :key="index"
                      class="page-item"
                      :class="{ active: page === currentPage }"
                    >
                      <a
                        href="javascript:void(0)"
                        class="page-link"
                        @click.prevent="changePage(page)"
                      >
                        {{ page }}
                      </a>
                    </li>
                    <li class="page-item" :class="{ disabled: currentPage === last_page }">
                      <a class="page-link" href="#" @click.prevent="changePage(currentPage + 1)">
                        <i class="fa fa-caret-right"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </nav>
          </div>
        </card>
      </div>
    </div>

    <!-- MODAL: Detailed Info -->
    <modal :show.sync="showDetails" class="user-modal">
      <span slot="header" class="title title-up text-primary assign-coures" style="width: 100%">
        Activity Details
      </span>
      <div class="col-md-12">
        <el-table
          :data="tableDataHistory"
          stripe
          highlight-current-row
          lazy
          row-key="id"
          id="tableModal"
          header-row-class-name="thead-light"
          class="loginReportGrid table-striped"
          style="max-height: 600px; overflow-y: auto;"
        >
          <el-table-column min-width="140px" prop="activity_type_label" label="Activity" />
          <el-table-column min-width="140px" prop="performed_by_name" label="Performed By" />
          <el-table-column min-width="140px" prop="performed_on_name" label="Performed On" />
          <el-table-column min-width="180px" prop="description_text" label="Description" />
          <el-table-column min-width="130px" prop="created_at" label="Activity Date" />
        </el-table>
      </div>
    </modal>
  </div>
</template>

<script>
import {
  DatePicker,
  Table,
  TableColumn,
  Select,
  Option,
  OptionGroup
} from "element-ui";
import serverSidePaginationMixin from "../Tables/PaginatedTables/serverSidePaginationMixin";
import XLSX from "xlsx";
import moment from "moment";

let timeout = null;

export default {
  name: "UserActivityHistory",
  mixins: [serverSidePaginationMixin],
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [OptionGroup.name]: OptionGroup,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [DatePicker.name]: DatePicker,
  },
  data() {
    return {
      // For the modal
      showDetails: false,
      tableDataHistory: [],

      // Loading overlay
      loading: false,

      // Filters
      searchQuery: "",
      showSuperAdmin: false, // Default: disabled (don't show Super Admin entries)
      filters: {
        activity_type: "0", // "All" is selected by default
        employeStatus: "2", // "All" for user status
        report_date: [
          moment().subtract(7, "days").format("MM/DD/YYYY"),
          moment().format("MM/DD/YYYY")
        ],
        user_type: "", // "All" for user type
      },
      userTypeOptions: [
        { label: "All", value: "" },
        { label: "Individual", value: "individual" },
        { label: "Company", value: "company" },
      ],
      showUserTypeFilter: ["super-admin", "sub-admin"].includes(localStorage.getItem("hot-user")),

      // For the table
      tableData: [],
      totalData: 0,

      // Options for User Status filter
      status: [
        { label: "Active", value: "1" },
        { label: "Inactive", value: "0" },
        { label: "All", value: "2" },
      ],

      // Activity Type Options grouped by category
      activityTypeOptions: [
        {
          label: "General",
          options: [
            { label: "All", value: "0" }
          ]
        },
        {
          label: "Course Management",
          options: [
            { label: "Assign Course", value: "1" },
            { label: "Unassigned Course", value: "6" },
            { label: "Course Passed", value: "8" },
            { label: "Course Failed", value: "9" },
            { label: "Manual Grade", value: "4" },
            { label: "Course Created", value: "10" },
            { label: "Course Updated", value: "11" },
            { label: "Course Deleted", value: "12" },
          ]
        },
        {
          label: "User Management",
          options: [
            { label: "Activate User", value: "2" },
            { label: "Inactivate User", value: "21" },
            { label: "Created User", value: "5" },
            { label: "Location Transfer", value: "7" },
            { label: "Password Changed", value: "15" },
            { label: "Profile Updated", value: "16" },
            { label: "Deleted User", value: "24" },
          ]
        },
        {
          label: "Others",
          options: [
            { label: "Sent Mail", value: "3" },
          ]
        }
      ],

      // For Excel export
      items: [],


      // details show related variables
      detailsTooltip:'',
      courses:null,
      targetUsers:null,
      locations:null

    };
  },
  watch: {
    // Debounce search query changes
    searchQuery() {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        this.fetchData();
      }, 300);
    },
  },
  created() {
    this.sortedColumn = null;
    this.order = 'desc';
    this.fetchData();
  },
  methods: {
    // Show detail modal for a specific record
    showDetailsModal(activityId) {
      this.loading = true;
      this.$http
        .post("user/activity-details", { id: activityId })
        .then((resp) => {
          this.tableDataHistory = resp.data.history || [];
          this.showDetails = true;
        })
        .finally(() => (this.loading = false));
    },

    // Clear all filters
    resetFilters() {
      this.searchQuery = "";
      this.showSuperAdmin = false; // Reset switch to default
      this.filters.activity_type = "0";
      this.filters.employeStatus = "2";
      this.filters.user_type = "";
      this.filters.report_date = [
        moment().subtract(7, "days").format("MM/DD/YYYY"),
        moment().format("MM/DD/YYYY")
      ];
      this.fetchData();
    },

    // Handle Super Admin switch toggle
    onSuperAdminToggle() {
      this.changePage(1); // Reset to first page when toggle changes
    },

    // Fetch data for the main table
    fetchData() {
      this.loading = true;
      this.$http
        .post("user/activity-report", {
          search: this.searchQuery,
          page: this.currentPage,
          column: this.sortedColumn, // from pagination mixin
          order: this.order,         // from pagination mixin
          report_start_date: this.filters.report_date?.[0],
          report_end_date: this.filters.report_date?.[1],
          per_page: this.perPage,
          status: this.filters.employeStatus,
          activity_type: this.filters.activity_type,
          show_super_admin: this.showSuperAdmin, // Include Super Admin filter
          user_type: this.filters.user_type,
          isExcelDownload: false,
        })
        .then((resp) => {
          this.courses = resp.data.courses || [];
          this.targetUsers = resp.data.targetUsers || [];
          this.locations = resp.data.locations || [];

          const report_data = resp.data.report || [];
          this.totalData = resp.data.total || 0;
          // Format table data if needed
          this.tableData = report_data.map((item) => ({
            id: item.id,
            user_id: item.user_id,
            activity_type_label: item.activity_type_label,
            performed_by_name: item.performed_by_name,
            performed_on_name: item.performed_on_name,
            description_text: item.description_text,
            created_at: moment(item.created_at).format("MM-DD-YYYY HH:mm"),
          }));
        })
        .finally(() => (this.loading = false));
    },

    downloadUserReport(userId) {
  this.loading = true;
  this.$http({
    method: 'post',
    url: 'user/activity-report-by-user',
    data: { user_id: userId },
    responseType: 'blob'
  })
  .then(response => {
    const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `user_activity_history_${userId}.xlsx`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  })
  .catch(error => {
    console.error('Error downloading the Excel file', error);
  })
  .finally(() => {
    this.loading = false;
  });
},

    // Excel export function
    exportExcel() {
      this.loading = true;
      this.$http
        .post("user/activity-report", {
          search: this.searchQuery,
          page: this.currentPage,
          column: this.sortedColumn,
          order: this.order,
          report_start_date: this.filters.report_date?.[0],
          report_end_date: this.filters.report_date?.[1],
          per_page: this.perPage,
          status: this.filters.employeStatus,
          activity_type: this.filters.activity_type,
          show_super_admin: this.showSuperAdmin, // Include Super Admin filter
          user_type: this.filters.user_type,
          isExcelDownload: true,
        })
        .then((resp) => {
          const report_data = resp.data.download || [];
          this.items = report_data;
          const sheet = XLSX.utils.json_to_sheet(this.items);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, sheet, "data");
          XLSX.writeFile(wb, "UserActivityHistory.xlsx");
        })
        .finally(() => (this.loading = false));
    },

    // == start functions related to description's ids hover and click

    formatDescription(description) {
      if (!description) return [];

      const parts = [];
      const regex = /(?:user|course|location)|\d+/gi; // Matches "user", "course", "location", or numbers
      let lastType = null; // Tracks the last type (user, course, location)
      let lastIndex = 0;

      description.replace(regex, (match, index) => {
        // Add the text before the match
        if (index > lastIndex) {
          parts.push({ text: description.slice(lastIndex, index), type: null, number: null });
        }

        // Check if the match is a type or a number
        if (isNaN(match)) {
          // If it's a type, update the lastType
          lastType = match.toLowerCase();
          parts.push({ text: `${match} `, type: null, number: null }); // Add the type as plain text
        } else {
          // If it's a number, associate it with the lastType
          parts.push({
            text: match,
            type: lastType,
            number: match,
          });
        }

        // Update the last index
        lastIndex = index + match.length;
      });

      // Add the remaining text after the last match
      if (lastIndex < description.length) {
        parts.push({ text: description.slice(lastIndex), type: null, number: null });
      }

      return parts;
    },

    handleNumberClick(id, type) {
      if (type === 'user') {
        this.$router.push({ path: '/add_employee', query: { id } });
      } else if (type === 'course') {
        this.$router.push({ path: '/edit_course', query: { id } });
      } else if (type === 'location') {
        this.$router.push({ path: '/edit_company', query: { id } });
      }
    },

    handleNumberHover(id, type) {

      this.detailsTooltip = '';
      if (type === 'user' && this.targetUsers[id]) {
        this.detailsTooltip = this.targetUsers[id].type.toUpperCase() +': '+ this.capitalizeWords(this.targetUsers[id].name) +', '+ this.targetUsers[id].email;
      } else if (type === 'course' && this.courses[id]) {
        this.detailsTooltip = this.courses[id].name;
      } else if (type === 'location' && this.locations[id]) {
        this.detailsTooltip = this.locations[id].name;
      }

      if (this.detailsTooltip === '')
        this.detailsTooltip = `This ${type} does not exist`;
    },

    fetchHoverDetails(url) {
      // this.loading = true; // Show a loading indicator if needed
      this.$http
        .get(url) // Replace with your API endpoint
        .then((resp) => {
          const details = resp.data.details || "No details available";
          this.detailsTooltip = details;
          // this.showHoverDetails(details, number);
        })
        .catch((error) => {
          console.error("Error fetching hover details:", error);
        });
    },
    // == end functions related to description's ids hover and click

    capitalizeWords(text) {
      if (!text) return '';
      return text
        .toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    },
  },
};
</script>

<style scoped>
  .no-border-card .card-footer {
    border-top: 0;
  }
  .pagination-select {
    display: inline-block !important;
    width: auto !important;
  }
  .pagination-select >>> .el-input {
    width: auto !important;
  }
  .pagination-select >>> .el-input__inner {
    width: auto !important;
    padding: 0 20px 0 6px !important;
    height: 28px !important;
    line-height: 28px !important;
    font-size: 13px !important;
    min-width: auto !important;
  }
  .pagination-select >>> .el-input__suffix {
    right: 5px;
  }

  /* Responsive table adjustments */
  @media only screen and (max-width: 1024px) {
    .loginReportGrid >>> table.el-table__body td:nth-of-type(1):before {
      content: "Activity";
    }
    .loginReportGrid >>> table.el-table__body td:nth-of-type(2):before {
      content: "Performed By";
    }
    .loginReportGrid >>> table.el-table__body td:nth-of-type(3):before {
      content: "Performed On";
    }
    .loginReportGrid >>> table.el-table__body td:nth-of-type(4):before {
      content: "Description";
    }
    .loginReportGrid >>> table.el-table__body td:nth-of-type(5):before {
      content: "Activity Date";
    }
  }
</style>
